<div class="splash">
    <div class="content">
        <img src="../../../assets/images/logo.svg" alt="Bayer" class="logo">

        <h2>Coming<br> Soon!</h2>
        <h3>WE ARE BUILDING A TRULY IMMERSIVE VIRTUAL EXPERIENCE FOR YOU TO ENJOY.</h3>
        <p>We invite you to return and explore our virtual environment when we go <em>LIVE</em> for the <em>ASCO GU</em> virtual meeting on <em>Thursday, February 11, 2021</em>.</p>
        <p>We look forward to connecting with you then.</p>
    </div>
</div>
